import GetPhone from "./components/getPhone";
import SetOTP from "./components/setOTP";
import "./App.css";
import { useState } from "react";

function App() {
  const [showOTP, setShowOTP] = useState(false);
  const [phone, setPhone] = useState("");

  return (
    <div className="App">
      {!showOTP ? (
        <GetPhone setShowOTP={setShowOTP} phone={phone} setPhone={setPhone} />
      ) : (
        <SetOTP phone={phone} />
      )}
    </div>
  );
}

export default App;
